import Rule from "../../../../common/rule";
import FootballState from "../../../state/football-state";

export default class Onside extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return [
            FootballState.KickNotRecovered,
            FootballState.KickRecovered
        ].some((state) => fragment.associatedState === state);
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.setFieldPosition(fragment.recoveredAt);
        gameContext.setPossessionForTeamId(fragment.recoveredBy.teamId);
        gameContext.setCurrentPlayerInPossession(fragment.recoveredBy);
    }
}
